/**
 * 颜色处理库：Hex 转 RGBA 或 混合颜色
 */
const ColorUtils = {
  // Hex 转 {r,g,b}
  hexToRgb(hex) {
    let s = hex.replace(/^#/, '')
    if (s.length === 3) {
      s = s[0] + s[0] + s[1] + s[1] + s[2] + s[2]
    }
    const num = parseInt(s, 16)
    return {
      r: (num >> 16) & 255,
      g: (num >> 8) & 255,
      b: num & 255
    }
  },

  // 计算透明度版本
  toRgba(hex, alpha) {
    const rgb = this.hexToRgb(hex)
    return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`
  },

  // 颜色混合 (模拟 color-mix)
  // weight 为 color2 的比例 (0-1)
  mix(color1, color2, weight) {
    const rgb1 = this.hexToRgb(color1)
    const rgb2 = this.hexToRgb(color2)
    const w1 = 1 - weight
    const w2 = weight
    const r = Math.round(rgb1.r * w1 + rgb2.r * w2)
    const g = Math.round(rgb1.g * w1 + rgb2.g * w2)
    const b = Math.round(rgb1.b * w1 + rgb2.b * w2)
    return `rgb(${r}, ${g}, ${b})`
  }
}

/**
 * 动态应用后端配置的主题色与圆角
 * @param {Object} siteConfig - 前端从 window._config 获取的站点配置
 */
export function applyThemeConfig(siteConfig) {
  if (!siteConfig || !document.documentElement) return

  const root = document.documentElement

  // 1. 映射基础主题色 (themeColor -> --base-color)
  if (siteConfig.themeColor) {
    const baseColor = siteConfig.themeColor
    root.style.setProperty('--base-color', baseColor)

    // 优化：仅在不支持 color-mix 的低端设备上预计算详细颜色变量
    const supportsColorMix =
      window.CSS && window.CSS.supports && window.CSS.supports('color: color-mix(in srgb, red, white)')

    if (!supportsColorMix) {
      // 预计算所有透明度阶梯 (兼容 color-mix)
      const alphaMap = {
        '--base-color-alpha-1': 0.01,
        '--base-color-alpha-5': 0.05,
        '--base-color-alpha-10': 0.1,
        '--base-color-alpha-40': 0.4,
        '--base-color-alpha-50': 0.5,
        '--base-color-alpha-70': 0.7,
        '--base-color-alpha-80': 0.8,
        '--base-color-alpha-85': 0.85,
        '--base-color-alpha-90': 0.9
      }

      Object.entries(alphaMap).forEach(([prop, alpha]) => {
        root.style.setProperty(prop, ColorUtils.toRgba(baseColor, alpha))
      })

      // 预计算深浅色混色
      root.style.setProperty('--base-color-blackness-20', ColorUtils.mix(baseColor, '#000000', 0.2))
      root.style.setProperty('--base-color-lightness-95', ColorUtils.mix(baseColor, '#ffffff', 0.95))
      root.style.setProperty('--base-color-lightness-90', ColorUtils.mix(baseColor, '#f4f4f4', 1))
    }
  }

  // 2. 映射购物车颜色 (btnCartColor -> --cart-color)
  if (siteConfig.btnCartColor) {
    root.style.setProperty('--cart-color', siteConfig.btnCartColor)
  }

  // 3. 映射圆角配置 (btnStyle -> --border-radius-base)
  if (siteConfig.btnStyle !== undefined) {
    const radius =
      typeof siteConfig.btnStyle === 'number' ? `${siteConfig.btnStyle}px` : siteConfig.btnStyle
    root.style.setProperty('--border-radius-base', radius)
  }
}
